import { Stack, Typography, Tooltip, Button, useTheme } from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  getRemoveButtonSx,
  getInfoTextIconSx,
  getHeaderLabelTypoSx,
  tooltipPopperProps,
} from './dropdownConsts';
import { getSolidThemeGray } from 'utility/styles';
import { useTranslation } from 'react-i18next';
interface DropdownHeaderProps {
  label: string;
  infoText?: string;
  disabled?: boolean;
  valueIsEmpty?: boolean;
  alwaysShowRemove?: boolean;
  onRemove: () => void;
}

export const DropdownHeader = ({
  label,
  infoText = '',
  disabled = false,
  valueIsEmpty = true,
  alwaysShowRemove = false,
  onRemove,
}: DropdownHeaderProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const removeDisabled = !alwaysShowRemove && (disabled || valueIsEmpty);

  return (
    <Stack
      direction="column"
      sx={{
        background: getSolidThemeGray(theme),
        borderBottom: `1px solid ${theme.palette.action.selected}`,
        p: 1,
        gap: 1,
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Tooltip
          title={infoText}
          arrow={false}
          disableInteractive={true}
          enterDelay={500}
          placement="bottom-start"
          slotProps={{
            popper: tooltipPopperProps,
          }}
        >
          <Typography
            sx={getHeaderLabelTypoSx}
            aria-label={`${label} - ${infoText}`}
          >
            {label}
            {infoText ? <InfoOutlinedIcon sx={getInfoTextIconSx} /> : null}
          </Typography>
        </Tooltip>
        <Button
          data-testid="dropdown-header-close-btn"
          variant="text"
          size="small"
          color="error"
          disabled={removeDisabled}
          startIcon={<RemoveCircleOutlineIcon />}
          sx={getRemoveButtonSx}
          onClick={onRemove}
        >
          {t('blox.actions.remove')}
        </Button>
      </Stack>
    </Stack>
  );
};
